import { DebugInfoProcessor } from './DebugInfoProcessor';
export const getDebugInfo = (context, contractInfo) => new DebugInfoProcessor(context, contractInfo).process();

//# sourceMappingURL=getDebugInfo.js.map
